<form [formGroup]="form" (ngSubmit)="onSubmit()" autocomplete="off">

    <nav class="toolbar navbar navbar-light">
        <div class="form-inline">
            <button class="btnback btn btn-outline-success" type="button" title="Volver" (click)="onBack()"><i class="fa fa-chevron-left"></i></button>
            <button *ngIf="!visibilitySpinner " type="submit" class="btn btn-outline-success" title="Guardar"><i class="fa fa-save"></i> Guardar</button>
            <button *ngIf="visibilitySpinner " type="button" [disabled]="true" class="btn btn-outline-success">
                <p-progressSpinner class="spinnerExcel"></p-progressSpinner>
                Guardando
            </button>
          
        </div>
    </nav>

    <app-migracionusuariopopup (selected)="onAcceptDialogUsuarioExterno($event)"></app-migracionusuariopopup>



    <!--Formulario ALTA o EDICION USUARIO EXTERNO-->
    <div class="animated fadeIn container-fluid">
        <h4>{{editTitle}} Usuario Externo</h4>

        <div class="row">
            <div class="col-md-12">

                <div class="card card-accent-success animated fadeIn">

                    <a class="card-header-a" (click)="isCollapsedDatosGen = !isCollapsedDatosGen" [attr.aria-expanded]="!isCollapsedDatosGen"
                       aria-controls="collapseExample">
                        <div class="card-header-buscador">
                            <i class="fa fa-filter"></i> Datos Generales
                            <i *ngIf="isCollapsedDatosGen" class="fa fa-caret-down float-right"></i>
                            <i *ngIf="!isCollapsedDatosGen" class="fa fa-caret-up float-right"></i>
                        </div>
                    </a>
                    <div class="card-body-detalle">

                        <div class="collapse group-filtros" id="collapseDatosGen" [ngbCollapse]="isCollapsedDatosGen">

                            <div class="row">
                                <div class="form-group col-md-4">
                                    <label class="col-form-label" for="inpNombreUsuarioCexveg">Nombre Usuario Cexveg</label>
                                    <input class="form-control" formControlName="NombreUsuarioCexveg"
                                           inputStyleClass="form-control" type="text" value="">
                                </div>

                                <div class="form-group col-md-4">
                                    <label class="col-form-label" for="inpActivo">Activo</label>
                                    <p-toggleButton class="form-control-togglebutton" formControlName="Activo" onLabel="Sí" offLabel="NO" (onChange)="onSelectActivo()"
                                                    onIcon="pi pi-check" offIcon="pi pi-times"></p-toggleButton>
                                </div>
                            </div>

                            <div class="row">

                                <div class="form-group col-md-4">
                                    <label class="col-form-label" for="inpFechaCreacion">Fecha Creación</label>
                                    <p-calendar readonlyInput="true" formControlName="FechaCreacion" inputStyleClass="form-control" utc="true" [showIcon]="true" [firstDayOfWeek]="1" dateFormat="dd/mm/yy"></p-calendar>
                                </div>

                                <div class="form-group col-md-4">
                                    <label class="col-form-label" for="inpFechaActivacion">Fecha Activación</label>
                                    <p-calendar readonlyInput="true" formControlName="FechaActivacion" inputStyleClass="form-control" utc="true" [showIcon]="true" [firstDayOfWeek]="1" dateFormat="dd/mm/yy"></p-calendar>
                                </div>

                                <div class="form-group col-md-4">
                                    <label class="col-form-label" for="inpFechaBaja">Fecha Baja</label>
                                    <p-calendar readonlyInput="true" formControlName="FechaBaja" inputStyleClass="form-control" utc="true" [showIcon]="true" [firstDayOfWeek]="1" dateFormat="dd/mm/yy"></p-calendar>
                                </div>

                            </div>

                        </div>

                    </div>

                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-12">
                <div class="card card-accent-success animated fadeIn">

                    <div class="card-header-buscador">
                        <i class="fa fa-plus"></i> <strong id="stPerfil">Perfiles</strong>
                        <label class="col-form-label required-field" for="stPerfil"></label>
                    </div>
                    <div class="card-body-detalle-list pb-3">

                        <div class="row">
                            <!--<div class="col-md-6">

                                <div class="form-group">
                                    <div class="input-group">

                                        <ng-select class="ngselect-listbox" [(items)]="listPerfilesSolicitantes"
                                                   bindLabel="Descripcion"
                                                   bindValue="Id"
                                                   formControlName="IdPerfil"
                                                   loadingText="Cargando..."
                                                   [loading]="!listPerfilesSolicitantes"
                                                   notFoundText="Perfil no encontrado"
                                                   placeholder="-- Seleccione un Perfil --"
                                                   clearAllText="Eliminar selección"
                                                   [ngClass]="displayFieldCssNgSelect('IdPerfil')"
                                                   [readonly]="readonly">
                                        </ng-select>

                                        <span class="input-group-btn">
                                            <button name="btnAddPerfil" class="btn btn-list btn-secondary btn-listbox"
                                                          type="button" title="Añade un Perfil" (click)="onAddPerfil()" [disabled]="readonly"><i class="fa fa-plus"></i>
                                                  </button>
                                        </span>                                        

                                    </div>
                                </div>
                            </div>-->

                            <div class="col-md-6">

                                <label class="cabeceraTablaDetalles">Perfiles</label>
                                <table class="table table-list table-sm">
                                    <!-- table-responsive -->
                                    <tbody>
                                        <tr *ngFor="let item of usuario.TUsuarioPerfilCollection">
                                            <td scope="col">
                                                <div class="btn-group">
                                                    <!--<button (click)="onDeletePerfil(item)" type="button" title="Eliminar perfil"
                                                            class="btn btn-sm btn-danger btn-listbox" [disabled]="readonly">
                                                            <i class="fa fa-remove"></i>
                                                    </button>-->
                                                </div>
                                            </td>
                                            <td scope="col" class="td-list">{{item.Descripcion}}</td>
                                        </tr>
                                    </tbody>
                                </table>

                                <div class="invalid-feedback-collectionlist d-block" *ngIf="isFieldInvalidNoSubmit('IdPerfil','required')">
                                    * Debe especificar un perfil.
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-md-12">

                <div class="card card-accent-success animated fadeIn">

                    <a class="card-header-a" (click)="isCollapsedDatosUser = !isCollapsedDatosUser" [attr.aria-expanded]="!isCollapsedDatosUser"
                       aria-controls="collapseExample">
                        <div class="card-header-buscador">
                            <i class="fa fa-filter"></i> Datos del Usuario (CAS)
                            <i *ngIf="isCollapsedDatosUser" class="fa fa-caret-down float-right"></i>
                            <i *ngIf="!isCollapsedDatosUser" class="fa fa-caret-up float-right"></i>
                        </div>
                    </a>
                    <div class="card-body-detalle">

                        <div class="collapse group-filtros" id="collapseDatosUser" [ngbCollapse]="isCollapsedDatosUser">

                            <div class="row">

                                <div class="form-group col-md-3">

                                    <label class="col-form-label required-field" for="inpNombre">Nombre</label>
                                    <input class="form-control" formControlName="Nombre" maxlength="100"
                                           inputStyleClass="form-control" type="text" value=""
                                           [ngClass]="displayFieldCss('Nombre')" [readonly]="readonly">

                                    <div class="invalid-feedback" *ngIf="isFieldInvalid('Nombre','required')">
                                        El Nombre es obligatorio
                                    </div>

                                </div>

                                <div class="form-group col-md-6">
                                    <label class="col-form-label required-field" for="inpApellidos">Apellidos</label>
                                    <input class="form-control" formControlName="Apellidos" maxlength="100"
                                           inputStyleClass="form-control" type="text" value="" [ngClass]="displayFieldCss('Apellidos')" [readonly]="readonly">

                                    <div class="invalid-feedback" *ngIf="isFieldInvalid('Apellidos','required')">
                                        Los Apellidos son obligatorios
                                    </div>

                                </div>

                                <div class="form-group col-md-3">
                                    <label class="col-form-label required-field" for="inpNif">NIF</label>
                                    <input formControlName="Nif" name="Nif" class="form-control" maxlength="17"
                                           inputStyleClass="form-control" type="text" value="" [ngClass]="displayFieldCss('Nif')" [readonly]="readonly">

                                    <div class="invalid-feedback" *ngIf="isFieldInvalid('Nif','required')">
                                        El Nif es obligatorio
                                    </div>

                                    <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('Nif','NIF')">
                                        Formato de NIF incorrecto
                                    </div>

                                    <div class="invalid-feedback" *ngIf="isFieldInvalid('Nif','nif_duplicated')">
                                        El NIF ya existe en la base de datos
                                    </div>
                                </div>

                            </div>

                        </div>

                    </div>

                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-md-12">

                <div class="card card-accent-success animated fadeIn">

                    <a class="card-header-a" (click)="isCollapsedDatosContacto = !isCollapsedDatosContacto" [attr.aria-expanded]="!isCollapsedDatosContacto" aria-controls="collapseExample">
                        <div class="card-header-buscador">
                            <i class="fa fa-filter"></i> Datos de Contacto
                            <i *ngIf="isCollapsedDatosContacto" class="fa fa-caret-down float-right"></i>
                            <i *ngIf="!isCollapsedDatosContacto" class="fa fa-caret-up float-right"></i>
                        </div>
                    </a>
                    <div class="card-body-detalle">

                        <div class="collapse group-filtros" id="collapsedDatosContacto" [ngbCollapse]="isCollapsedDatosContacto">

                            <div class="row">

                                <div class="form-group col-md-4">
                                    <label class="col-form-label required-field" for="inpEmail">Email</label>
                                    <input class="form-control" formControlName="Email" maxlength="100"
                                           inputStyleClass="form-control"
                                           [readonly]="readonly"
                                           type="text" value="" [ngClass]="displayFieldCss('Email')">

                                    <div class="invalid-feedback" *ngIf="isFieldInvalid('Email','required')">
                                        El email es obligatorio
                                    </div>

                                    <div class="invalid-feedback" *ngIf="isFieldInvalid('Email','email')">
                                        Formato incorrecto.
                                    </div>

                                    <div class="invalid-feedback" *ngIf="isFieldInvalid('Email','email_duplicated')">
                                        El email ya existe en la base de datos
                                    </div>
                                </div>

                                <div class="form-group col-md-4">

                                    <label class="col-form-label required-field" for="inpNumeroTelefono">Nº Teléfono</label>
                                    <input class="form-control" formControlName="NumeroTelefono" maxlength="20"
                                           inputStyleClass="form-control" type="text" value=""
                                           [ngClass]="displayFieldCss('NumeroTelefono')">

                                    <div class="invalid-feedback" *ngIf="isFieldInvalid('NumeroTelefono','required')">
                                        El número de teléfono es obligatorio
                                    </div>

                                </div>

                                <div class="form-group col-md-4">

                                    <label class="col-form-label" for="inpNumeroFax">Nº Fax</label>
                                    <input class="form-control" formControlName="NumeroFax" maxlength="50"
                                           inputStyleClass="form-control" type="text" value="" [ngClass]="displayFieldCss('NumeroFax')">

                                    <div class="invalid-feedback" *ngIf="isFieldInvalid('NumeroFax','required')">
                                        El número de Fax es obligatorio
                                    </div>

                                </div>

                            </div>

                        </div>

                    </div>

                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-md-12">

                <div class="card card-accent-success animated fadeIn">

                    <a class="card-header-a" (click)="isCollapsedDatosRep = !isCollapsedDatosRep" [attr.aria-expanded]="!isCollapsedDatosRep" aria-controls="collapseExample">
                        <div class="card-header-buscador">
                            <i class="fa fa-filter"></i> Datos del Representante
                            <i *ngIf="isCollapsedDatosRep" class="fa fa-caret-down float-right"></i>
                            <i *ngIf="!isCollapsedDatosRep" class="fa fa-caret-up float-right"></i>
                        </div>
                    </a>
                    <div class="card-body-detalle">

                        <div class="collapse group-filtros" id="collapseDatosRep" [ngbCollapse]="isCollapsedDatosRep">

                            <div class="row">

                                <div class="form-group col-md-3">

                                    <label class="col-form-label required-field" for="inpNombreRep">Nombre</label>
                                    <input class="form-control" formControlName="NombreRepresentante" maxlength="100"
                                           inputStyleClass="form-control" type="text" value=""
                                           [ngClass]="displayFieldCss('NombreRepresentante')" [readonly]="readonly">

                                    <div class="invalid-feedback" *ngIf="isFieldInvalid('NombreRepresentante','required')">
                                        El Nombre es obligatorio
                                    </div>

                                </div>

                                <div class="form-group col-md-6">
                                    <label class="col-form-label required-field" for="inpApellidosRep">Apellidos</label>
                                    <input class="form-control" formControlName="ApellidosRepresentante" maxlength="100"
                                           inputStyleClass="form-control" type="text"
                                           value="" [ngClass]="displayFieldCss('ApellidosRepresentante')" [readonly]="readonly">

                                    <div class="invalid-feedback" *ngIf="isFieldInvalid('ApellidosRepresentante','required')">
                                        Los Apellidos son obligatorios
                                    </div>

                                </div>

                                <div class="form-group col-md-3">
                                    <label class="col-form-label required-field" for="inpNifRepresentante">NIF</label>
                                    <input formControlName="NifRepresentante" name="Nif" class="form-control" maxlength="17"
                                           inputStyleClass="form-control" type="text"
                                           value="" [ngClass]="displayFieldCss('NifRepresentante')" [readonly]="readonly">

                                    <div class="invalid-feedback" *ngIf="isFieldInvalid('NifRepresentante','required')">
                                        El Nif es obligatorio
                                    </div>

                                    <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('NifRepresentante','NIF')">
                                        Formato de NIF incorrecto
                                    </div>
                                </div>

                            </div>

                        </div>

                    </div>

                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-md-12">

                <div class="card card-accent-success animated fadeIn">

                    <a class="card-header-a" (click)="isCollapsedDatosOrg = !isCollapsedDatosOrg" [attr.aria-expanded]="!isCollapsedDatosOrg" aria-controls="collapseExample">
                        <div class="card-header-buscador">
                            <i class="fa fa-filter"></i> Datos de la Organización
                            <i *ngIf="isCollapsedDatosOrg" class="fa fa-caret-down float-right"></i>
                            <i *ngIf="!isCollapsedDatosOrg" class="fa fa-caret-up float-right"></i>
                        </div>
                    </a>
                    <div class="card-body-detalle">

                        <div class="collapse group-filtros" id="collapsedDatosOrg" [ngbCollapse]="isCollapsedDatosOrg">

                            <div class="row">

                                <div class="form-group col-md-8">

                                    <label class="col-form-label required-field" for="inpRazonSocial">Razón Social</label>
                                    <input class="form-control" formControlName="RazonSocial" maxlength="255"
                                           [readonly]="readonly"
                                           inputStyleClass="form-control" type="text" value="" [ngClass]="displayFieldCss('RazonSocial')">

                                    <div class="invalid-feedback" *ngIf="isFieldInvalid('RazonSocial','required')">
                                        La Razón Social es obligatoria
                                    </div>

                                </div>

                                <div class="form-group col-md-4">
                                    <label class="col-form-label required-field" for="inpNifCifRazonSocial">NIF/CIF Razón Social</label>
                                    <input class="form-control" formControlName="NifCifRazonSocial" maxlength="17"
                                           [readonly]="readonly"
                                           inputStyleClass="form-control" type="text" value=""
                                           [ngClass]="displayFieldCss('NifCifRazonSocial')">

                                    <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('NifCifRazonSocial','required')">
                                        El Nif/Cif de la Razón Social es obligatorio
                                    </div>

                                    <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('NifCifRazonSocial','NIF')">
                                        Formato de NIF incorrecto
                                    </div>

                                </div>

                            </div>

                            <div class="row">

                                <div class="form-group col-md-4">
                                    <label class="col-form-label required-field" for="inpPais">País UE</label>

                                    <ng-select loadingText="Cargando..."
                                               [items]="listPais"
                                               placeholder="-- Seleccione un País --"
                                               [readonly]="!listPais || listPais.length === 0"
                                               [loading]="!listPais || listPais.length === 0"
                                               bindLabel="Descripcion"
                                               bindValue="Id"
                                               formControlName="IdPais"
                                               notFoundText="País no encontrado"
                                               clearAllText="Eliminar selección"
                                               [ngClass]="displayFieldCssNgSelect('IdPais')"
                                               (change)="onSelectPais()">
                                    </ng-select>

                                    <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('IdPais','required')">
                                        El País es obligatorio
                                    </div>

                                </div>

                                <div class="form-group col-md-4">
                                    <label class="col-form-label" for="inpProvincia" [ngClass]="{ 'required-field' : isEspania() }">Provincia</label>
                                    <ng-select loadingText="Cargando..."
                                               [items]="listProvincia"
                                               bindLabel="Descripcion"
                                               bindValue="Id"
                                               formControlName="IdProvincia"
                                               [readonly]="!listProvincia || listProvincia.length === 0"
                                               [loading]="(!listProvincia || listProvincia.length === 0) && isEspania()"
                                               notFoundText="Provincia no encontrada"
                                               placeholder="-- Seleccione una Provincia --"
                                               clearAllText="Eliminar selección"
                                               [ngClass]="displayFieldCssNgSelect('IdProvincia')"
                                               (change)="onSelectProvincia()">
                                    </ng-select>

                                    <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('IdProvincia','required')">
                                        La Provincia es obligatoria
                                    </div>

                                </div>

                                <div class="form-group col-md-4">
                                    <label class="col-form-label" for="inpIdMunicipio" [ngClass]="{ 'required-field' : isEspania() && !isCeutaMelilla()}">Municipio</label>
                                    <ng-select #municipio loadingText="Cargando..."
                                               [items]="listMunicipio"
                                               bindLabel="Descripcion"
                                               bindValue="Id"
                                               formControlName="IdMunicipio"
                                               [readonly]="!listMunicipio || listMunicipio.length === 0"
                                               [loading]="(!listMunicipio || listMunicipio.length === 0) && (form.value.IdProvincia > 0) && !isCeutaMelilla()"
                                               notFoundText="Municipio no encontrado"
                                               placeholder="-- Seleccione un Municipio --"
                                               [ngClass]="displayFieldCssNgSelect('IdMunicipio')"
                                               (change)="onSelectMunicipio()"
                                               clearAllText="Eliminar selección">
                                    </ng-select>

                                    <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('IdMunicipio','required')">
                                        El Municipio es obligatorio
                                    </div>

                                </div>

                            </div>

                            <div class="row">

                                <div class="form-group col-md-8">

                                    <label class="col-form-label required-field" for="inpLocalidadTraces">Localidad</label>
                                    <input class="form-control" formControlName="LocalidadTraces" maxlength="250"
                                           inputStyleClass="form-control" type="text" value="" [ngClass]="displayFieldCss('LocalidadTraces')">

                                    <div class="invalid-feedback" *ngIf="isFieldInvalid('LocalidadTraces','required')">
                                        La Localidad es obligatoria
                                    </div>

                                </div>

                                <div class="form-group col-md-4">
                                    <label class="col-form-label" for="inpTipoVia">Tipo Vía</label>

                                    <ng-select loadingText="Cargando..."
                                               [items]="listTipoVia"
                                               bindLabel="Descripcion"
                                               bindValue="Id"
                                               formControlName="IdTipoVia"
                                               [readonly]="!listTipoVia || listTipoVia.length === 0"
                                               [loading]="!listTipoVia || listTipoVia.length === 0"
                                               notFoundText="Tipo de Vía no encontrado"
                                               placeholder="-- Seleccione un Tipo de Vía --"
                                               clearAllText="Eliminar selección">
                                    </ng-select>

                                </div>
                            </div>

                            <div class="row">
                                <div class="form-group col-md-8">

                                    <label class="col-form-label" for="inpNombreVia">Nombre de la vía</label>
                                    <input class="form-control" formControlName="NombreVia" maxlength="250"
                                           inputStyleClass="form-control" type="text" value="" [ngClass]="displayFieldCss('NombreVia')">

                                </div>

                                <div class="form-group col-md-2">
                                    <label class="col-form-label" for="inpNumeroPortal">Número</label>
                                    <input class="form-control" formControlName="NumeroPortal" maxlength="50"
                                           inputStyleClass="form-control"
                                           type="text" ng-maxlength="4" value="" [ngClass]="displayFieldCss('NumeroPortal')">
                                </div>

                                <div class="form-group col-md-2">
                                    <label class="col-form-label required-field" for="inpCodigoPostal">Código Postal</label>
                                    <input class="form-control" formControlName="CodigoPostal" maxlength="15"
                                           inputStyleClass="form-control" id="inpCodPostal"
                                           value="" [ngClass]="displayFieldCss('CodigoPostal')">

                                    <div class="invalid-feedback" *ngIf="isFieldInvalid('CodigoPostal','pattern')">
                                        Formato incorrecto
                                    </div>

                                    <div class="invalid-feedback" *ngIf="isFieldInvalid('CodigoPostal','required')">
                                        Código postal es obligatorio
                                    </div>

                                </div>

                            </div>

                        </div>

                    </div>

                </div>
            </div>
        </div>

        <div class="row" *ngIf="!editMode">
            <div class="col-md-12">

                <div class="card card-accent-success animated fadeIn">

                    <a class="card-header-a" (click)="isCollapsedTerms = !isCollapsedTerms" [attr.aria-expanded]="!isCollapsedTerms" aria-controls="collapseExample">
                        <div class="card-header-buscador">
                            <i class="fa fa-filter"></i> Política de Protección de Datos
                            <i *ngIf="isCollapsedTerms" class="fa fa-caret-down float-right"></i>
                            <i *ngIf="!isCollapsedTerms" class="fa fa-caret-up float-right"></i>
                        </div>
                    </a>
                    <div class="card-body-detalle">

                        <div class="collapse group-filtros" id="collapsedTerms" [ngbCollapse]="isCollapsedTerms">

                            <div class="row">

                                <div class="form-group col-md-12">

                                    <label class="col-form-label required-field required-field-relative" for="inpTerms">Acepto la Política de Protección de Datos </label>
                                    <!--<input class="form-control-check" formControlName="Terms" inputStyleClass="form-control" type="checkbox" value=""
                                    [ngClass]="displayFieldCss('Terms')" id="inpTerms">-->
                                    <p-toggleButton class="form-control-togglebutton" formControlName="Terms" onLabel="Sí" offLabel="NO"
                                                    onIcon="pi pi-check" offIcon="pi pi-times" [ngClass]="displayFieldCssToggleButton('Terms')" id="inpTerms"></p-toggleButton>

                                    <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('Terms', 'requiredTrue')">
                                        Debe aceptar la Política de Protección de Datos para continuar.
                                    </div>

                                    <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('Terms', 'required')">
                                        Debe aceptar la Política de Protección de Datos.
                                    </div>
                                </div>

                            </div>

                        </div>

                    </div>

                </div>
            </div>
        </div>

    </div>
</form>
